import Popup from "./base/Popup";
import {pxToRem} from "../utils/util";
import {gsap} from "gsap";

import { 
    isA11ySetAttr,
    isA11yCheckVersion,
    isA11yRectList,
    isA11yRecListItem,
    isA11yReservationBtn,
    isA11yRadioGroup,
    isA11ySelectGroup,
    a11yDebounceLeading,
    a11yAcessFocus,
    isA11yCarouselSelect,
    isA11ySlidesAccess,
    isA11ySwiperSelect,
    isA11ySwiperPopupUpdate,
    isA11ySwiperBtnChangeAria,
    isDateSpinnerNextTextForceReading,
} from "../functions/a11y.ui";

import { isA11yDateSpinnerInput, isA11yScrollAnimation } from "../functions/simple.ui";
import ScrollAnimation from "./ScrollAnimation"; 

/**
 * PopupExternal
 *
 * 일반적인 ui-popup
 */

 
class PopupExternal extends Popup {

    swiperInstances = [];
    selectedIndexes = [];

    constructor(el, options) {
        super('popupExternal', el);

        this.init(el, options);
    }

    init(el, options) {
        this.popupInit(el, options);
        
        this.render();
        this.detachEvents();
        this.attachEvents();
    }

    update() {
        this.detachPopupEvents();
        this.attachPopupEvents();
    }

    render() {
        if (!this.$popup) {
            this.$popup = this.$el;
            this.$el = undefined;
            this.$popup.attr('data-id', this.uiId);

            this.update();
        }
    }

    // 20230120 애니메이션 후 콜백 함수 추가
    openMotion(cancelMotion, motionAftercallback) {
        if (this.$popup.find('[data-ani-count]').length > 0) { // FETASK-1641 팝업에  숫자 카운팅 있을때 재실행
            this.$popup.find('[data-ani-count]').text('0')
            setTimeout(()=>{
                frontUI.numberCountAni(this.$popup.find('[data-ani-count]'))
            },500)
            
        }
        if (this.openCallback && $.isFunction(this.openCallback)) {
            this.openCallback();
        } 
        this.openCommonMotion({
            cancelMotion,
            callback: () => {
                if (typeof motionAftercallback == 'function') motionAftercallback();
            }
        });
        
        /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
        this.a11yPopupAccess();
        /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
    }
    
    //[FETASK-822] 애니메이션 후 콜백 함수 추가
    closeMotion(cancelMotion, motionAftercallback) {
        //console.log('closemotion')
        //[FETASK-822] swiper의 activeIndex로 이동
        if(this.defaults.type === 'dateSpinner'){
            motionAftercallback = this.setSwiperSlideTo.bind(this);

            //radio버튼인 경우 
            const $toggleRadio = this.$popup.find('.ui-ToggleRadio');
            if($toggleRadio.length){
                setTimeout(() => {$toggleRadio.data('ui').restore()});
            }    
        }
        this.closeCommonMotion({
            cancelMotion,
            callback: () => {
                if (typeof motionAftercallback == 'function') motionAftercallback();
            }
        });

        /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
        this.a11yPopupInit();
        /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
    }

    //[FETASK-822] swiper의 activeIndex 저장
    saveSwiperActiveIdx() {
        const that = this.defaults.area ? this.$el.closest('.ui-popup').data('ui') : this.$popup.data('ui');
        that.swiperInstances = this.swiperInstances || [];
        that.selectedIndexes = that.selectedIndexes || [];

        //console.log('that', that.swiperInstances);

        if(that.swiperInstances.length){
            //[FETASK-1038] selectedIndexes 저장 및 업데이트 2023-06-05
            const selectedIndexLen = that.selectedIndexes.length;
            that.swiperInstances.forEach((swiper, i) => {
                selectedIndexLen ? that.updateSwiperIndex(swiper.activeIndex, i) : that.selectedIndexes.push(swiper.activeIndex);
            })
        }

        return {
            callback: function(func){
                if (typeof func == 'function') {
                    func();
                }
            }            
        }        
    }  

    updateSwiperIndex(activeIndex, index){
        this.selectedIndexes[index] = activeIndex;
    }
    
    //[FETASK-822] 저장된 selectedIndex로 이동
    setSwiperSlideTo(event){
        this.selectedIndexes.length && this.swiperInstances.forEach((swiper, i) => {
            swiper.slideTo(this.selectedIndexes[i], 0, false);
        })
    }
    /**
     * @param  {boolean} cancelMotion  true일 경우 팝업 애니메이션의 시간을 0초로 한다.
     * @param  {boolean} hidden  팝업 visible 유무  defalut : false
     * @example 
     * $('.ui-popup').data('ui').open(false, false);
     */
    open(cancelMotion = false, hidden = false) {
        // 20230120 애니메이션 후 콜백 함수 추가
        let callbackFunc;
        //[FETASK-822] swiper의 activeIndex 설정을 위한 callback 추가
        if(this.defaults.type === 'dateSpinner'){
            callbackFunc = this.saveSwiperActiveIdx.bind(this);            
            setTimeout(() => {this.setSwiperSlideTo()},100);
        }

        this.openMotion(cancelMotion, () => {
            if (typeof callbackFunc == 'function') {
                callbackFunc();
            }
        });
        if(hidden){
            ////console.log(this.$popup)
            //gsap.killTweensOf(this.$popup);
            setTimeout(() => {
                this.$popup.css({display: 'none'});
            });
        }

        frontUI.scrollTransformView(); //상단 비주얼 요소 스크롤 모션 추가

        // [FETASK-1257] 각인문구 반팝업 resize
        if(this.el.querySelector('.meetcard-sample-group')){
            const resizeHeight = window.innerHeight * 0.7;
            const popupGrp = this.el.querySelector('.meetcard-sample-group').closest('.popup-group');

            popupGrp.style.height = popupGrp.clientHeight > resizeHeight && resizeHeight+'px';
        }

        // s: 팝업 spinner형태 재수정
        if(isA11yCheckVersion()){
            $(document).ready(() => {
                const uiSwiperEles = this.$popup?.find('.ui-swiper');
                
                uiSwiperEles?.length && uiSwiperEles?.each((_, item) => {
                    if($(item).hasClass('carousel-select-group')){
                        return;
                    }

                    if($(item).hasClass('carousel-popup-group')){
                        return;
                    }
                    
                    // 시작전 업데이트 실행;
                    $(item).data('ui').update();

                    setTimeout(() => {
                        const sw = $(item).data('ui').swiper;

                        sw.init();

                        const isActive = $(item).find('.swiper-slide.swiper-slide-active').index();
                        const slidesEle = $(item).find('.swiper-slide');
                        const ulWrap = $(item).find('.swiper-container')[0];
                            
                        //버튼 절대 좌표값 계산
                        //const getPageOffset = window.pageYOffset;
                        const swipeDivBox = ulWrap?.parentElement;
                        const ulGetBoundRect = swipeDivBox?.getBoundingClientRect();
                        const { top, width, bottom } = ulGetBoundRect;
                        const buttonHeight = 40;

                        const topOffset = top - buttonHeight;
                        const bottomOffset = bottom;

                        const selectText = slidesEle.eq(isActive).text();

                        const prevBtn = document.createElement('button');
                        prevBtn.classList.add('control-btn');
                        prevBtn.classList.add('prev__btn');

                        const nextBtn = document.createElement('button');
                        nextBtn.classList.add('control-btn');
                        nextBtn.classList.add('next__btn');

                        prevBtn.setAttribute('role','button');
                        prevBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${topOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`);                                    
                        
                        prevBtn.setAttribute('aria-label', `${selectText}, 이전 (감소 버튼)`);

                        nextBtn.setAttribute('role','button');
                        nextBtn.setAttribute('style', `${!width && 'visibility:visible'};position:fixed;top:${bottomOffset}px;width:${width ? width : 1}px;height:${buttonHeight}px;z-index:5;`); 

                        nextBtn.setAttribute('aria-label', `${selectText}, 다음 (증가 버튼)`);
                        
                        $(ulWrap).attr('role','presentation');
                        $(ulWrap).attr('aria-hidden','true');
                        if( item.dataset.createControl !== "false" ){
                            $(ulWrap)?.before(prevBtn);
                            $(ulWrap)?.after(nextBtn);
                        }

                        $(swipeDivBox).find('.prev__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
                            const swipe = $(e.currentTarget).closest('.group-spinner-swiper').data('ui').swiper;

                            const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                            //swipe.emit('activeIndexChange');
                            //swipe.emit('slideChangeTransitionEnd');

                            const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex - 1);

                            isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

                            if(activeIndex -1 >= 0){
                                swipe.slideTo(activeIndex - 1);
                            }

                            

                            //spinner변경 텍스트
                            setTimeout(() => {
                                let currentText = '';

                                const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
                
                                activeItems?.each((idx,list) => {
                                    currentText += list.innerText;
                                    currentText += ' ';
                                });
                
                                console.log('isA11ySwiperSpinnerUpdate currentText', currentText);
                
                                setTimeout(() => {
                                    const selectDiv = document.querySelector('.spinner-live');
                
                                    const createText = document.createElement('div');
                                    createText.innerText = `${currentText} 선택`;
                                    
                                    $(selectDiv)?.children().remove();
                
                                    ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
                
                                    setTimeout(() => {
                                        createText.remove();
                                    },2000);
                                },1000);
                            },500);
                        });

                        $(swipeDivBox).find('.next__btn')?.off('click.spinnerSwiper')?.on('click.spinnerSwiper', (e) => {
                            const swipe = $(e.currentTarget).closest('.group-spinner-swiper').data('ui').swiper;
                            
                            const activeIndex = $(e.currentTarget).parent().find('.swiper-slide.swiper-slide-active').index();

                            const maxLength = $(item).find('.swiper-slide')?.length;

                            const slidesEles = $(e.currentTarget).parent().find('.swiper-slide').eq(activeIndex + 1);

                            isDateSpinnerNextTextForceReading(e.currentTarget, slidesEles?.text());

                            //swipe.emit('activeIndexChange');
                            //swipe.emit('slideChangeTransitionEnd');

                            if(activeIndex + 1 < maxLength){
                                swipe.slideTo(activeIndex + 1);
                            }

                            //spinner변경 텍스트
                            setTimeout(() => {
                                let currentText = '';

                                const activeItems = $(e.currentTarget).parent().parent().find('.swiper-slide-active');
                
                                activeItems?.each((idx,list) => {
                                    currentText += list.innerText;
                                    currentText += ' ';
                                });
                
                                console.log('isA11ySwiperSpinnerUpdate currentText', currentText);
                
                                setTimeout(() => {
                                    const selectDiv = document.querySelector('.spinner-live');
                
                                    const createText = document.createElement('div');
                                    createText.innerText = `${currentText} 선택`;
                                    
                                    $(selectDiv)?.children().remove();
                
                                    ($(selectDiv)?.children()?.length === 0 && selectDiv) && selectDiv.append(createText);
                
                                    setTimeout(() => {
                                        createText.remove();
                                    },2000);
                                },1000);
                            },500);
                        });
                        

                        if($('#FPMDPT21000A300W')?.length){
                            slidesEle.each((item, idx) => {
                                if($(item).text() === '직접입력'){
                                    $(item).remove();
                                }
                            });
                        }

                        isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden


                        sw.on('slideChangeTransitionEnd', (sw) => {
                            const { activeIndex, slides } = sw;

                            console.log('slideChange');

                            if($(slides[activeIndex]).text() === '매월'){
                                $('#monthlyCyclSwiper').show();
                                $('#weeklyCyclSwiper').hide();
                            }

                            if($(slides[activeIndex]).text() === '매주'){
                                $('#monthlyCyclSwiper').hide();
                                $('#weeklyCyclSwiper').show();
                            }

                            const curText = slides[activeIndex]?.innerText;

                            //console.log('curText', slides);

                            $(swipeDivBox).find('.prev__btn').attr('aria-label', `${curText}, 이전 (감소 버튼)`);
                            $(swipeDivBox).find('.next__btn').attr('aria-label', `${curText}, 다음 (증가 버튼)`);

                            isA11ySwiperBtnChangeAria(); //스와이프 버튼 aria-hidden
                        });

                        setTimeout(() => {
                            $(swipeDivBox).find('.prev__btn').each((idx, item) => {
                                if(idx > 0){
                                    $(item).remove();
                                }
                            });
    
                            $(swipeDivBox).find('.next__btn').each((idx, item) => {
                                if(idx > 0){
                                    $(item).remove();
                                }
                            });

                            //$(this.$popup)?.focus();
                        },500);
                    },800);
                });
            });
        }
        // e: 팝업 spinner형태 재수정
        

        return {
            callback: function(c){callbackFunc = c;}
        }
    }
    /**
     * @param  {boolean} cancelMotion  defalut:false (true일 경우 팝업 애니메이션의 시간을 0초로 한다.)
     * @example 
     * $('.ui-popup').data('ui').close(false);
     */
    close(cancelMotion = false) {
        let callbackFunc;
        //[FETASK-822] activeIndex로 이동을 위한 callback 추가
        if(this.defaults.type === 'dateSpinner'){
            callbackFunc = this.setSwiperSlideTo.bind(this);
        }
        //console.log('여기?')
        this.closeMotion(cancelMotion, () => {    
            if (typeof callbackFunc == 'function') {
                callbackFunc();
            }
        });
        if (this.$popup.attr('data-origin-type') !== undefined) {
            const origin = this.$popup.attr('data-origin-type');
            if (origin === 'bottom') {// bottom to full case
                this.$popup.find('[data-show-type="bottom"]').show();
                this.$popup.find('[data-show-type="full"]').hide();
                this.$popup.find('.popup-group').css('height', '');
                this.$popup.closest('.ui-popup').addClass('ui-bottom').removeClass('ui-full ui-full-change');
            } else { //full to bottom case
                this.$popup.find('[data-show-type="full"]').show();
                this.$popup.find('[data-show-type="bottom"]').hide();
                this.$popup.closest('.ui-popup').addClass('ui-full').removeClass('ui-bottom ui-bottom-change');
            }
            this.$popup.find('.popup-group').css('height', '');
        }
        
        return {
            callback: function(c){callbackFunc = c;}
        }
    }
    /**
     * open 콜백
     * @param  {function} callback  
     * @example 
     * $('.ui-popup').data('ui').beforeOpenCallback(function(){});
     */
    beforeOpenCallback(callback) {
        this.openCallback = callback;
    }
    /**
     * close 콜백
     * @param  {function} callback  
     * @example 
     * $('.ui-popup').data('ui').beforeCloseCallback(function(){});
     */
    beforeCloseCallback(callback) {
        this.closeCallback = callback;
    }

    closeCallbackAction() {
        // 불필요시 삭제 : 퍼블 페이지 작업용
        //localStorage.removeItem('popList');  // 240115  안드로이드 에러 ?  주석처리
        if (this.$popup.attr('popup-show') == 'true') { // CHPFMTASK-801
            if (this.closeCallback && $.isFunction(this.closeCallback)) {
                this.closeCallback();
            } else {
                this.closeMotion();
            }
        } else {
            this.closeMotion();
        }
        // if (this.closeCallback && $.isFunction(this.closeCallback)) {
        //     this.closeCallback();
        // } else {
        //     this.closeMotion();
        // }
        isA11yScrollAnimation($('body')[0]);
        
    }

    attachPopupEvents() {
        this.$popup.on(`click${this.eventId}`, (e) => {
            //console.log('클릭 : ', this.$popup.attr('popup-show') )
            if (this.$popup.attr('popup-show') == 'true') {  //  CHPFMTASK-801
                if (e.target === e.currentTarget) {
                    this.closeCallbackAction();
                }
            }
            // if (e.target === e.currentTarget) {
            //     this.closeCallbackAction();
            // }
            //console.log('close popup', e.target === e.currentTarget)
        });      

        //[FETASK-822] click시 index 설정
        this.$popup.on(`click${this.eventId}`, '.btn-group .primary1', (e) => {
            const $toggleRadio = this.$popup.find('.ui-ToggleRadio');
            if($toggleRadio.length){
                $toggleRadio.data('ui').setActiveIndex();
            }    

            this.swiperInstances.length && this.swiperInstances.forEach((swiper, i) => {
                this.updateSwiperIndex(swiper.activeIndex, i);
            });
        });

        this.$popup.on(`keydown${this.eventId} click${this.eventId}`, '.btn-popup-close, .close-btn', (e) => {
            // 240626 PC 키보드 포커스 수정
            if($('html, body').hasClass('pc')) {
                if (e.type == 'click' || e.type === 'keydown' && e.keyCode == 13) {
                    e.preventDefault();
                    this.closeCallbackAction();
                }
            }else{
                if (e.type === 'keydown' && e.keyCode != 13) {
                    return false;
                }
                e.preventDefault();
                this.closeCallbackAction();
            } 
        })

        this.$dimm.on(`click${this.eventId}`, (e) => {
            e.preventDefault();
            if (this.$popup.attr('popup-show') == 'true') { // CHPFMTASK-801
                this.closeCallbackAction();
            }
            //this.closeCallbackAction();
            
            
        });

        this.$popup.on(`scroll${this.eventId}`, (e) => {
            if (this.$popup[0].scrollTop === 0) {
                this.$popup.find('.btn-popup-close').removeClass('scroll');
            } else {
                this.$popup.find('.btn-popup-close').addClass('scroll');
            }
        });
    }
    //  반팝업 -> 풀팝업 액션일때 사용 
    changeToFull(){
        //console.log('changeToFull')
        this.$popup.find('.popup-group').css({
            'height': this.$popup.find('.popup-group').outerHeight(true),
            'max-height':'none'
        })
        this.$popup.addClass('ui-full-change');
        this.$popup.attr('data-origin-type', 'bottom');
        this.$popup.find('[data-show-type="bottom"]').hide();
        this.$popup.find('[data-show-type="full"]').show();
        this.$popup.find('.popup-group').animate({
            'height': '100%'
        }, 300, function(){
            $(this).closest('.ui-popup').addClass('ui-full').removeClass('ui-bottom');
        });
        if (this.typeChange && $.isFunction(this.typeChange)) {
            this.typeChange();
        }
    }
    //  반팝업 -> 풀팝업 액션일일때 콜백
    changeCallback(callback){
        this.typeChange = callback
    }

    detachPopupEvents() {
        this.$popup.off(this.eventId);
        this.swiper && this.swiper.destroy();
    }

    destroy() {
        this.detachEvents();
        this.detachPopupEvents();
        this.swiper.destroy();
    }

    /*! s: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
    a11yPopupAccess(){
        //팝업 오픈 실행로직
        const _this = this;
        requestAnimationFrame(async() => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행
            if(isA11yCheck){
                const popupWrap = document.querySelector('.popup-wrap');
                popupWrap.removeAttribute('tabindex');

                const removeIdContent = document.querySelector('#content-mmk');
                removeIdContent?.setAttribute('aria-hidden','false')
                removeIdContent?.removeAttribute('aria-hidden');

                //내계좌(최근에 보낸 계좌) 삭제버튼 접근성 추가
                isA11yRectList();
                isA11yRecListItem();

                //돈 보내기 예약버튼 접근성
                isA11yReservationBtn(_this.$popup[0], true);

                isA11yRadioGroup(_this.$popup); //radiogroup적용

                isA11ySelectGroup(_this.$popup); //팝업 select-container형태 셀렉트 리스트 접근성

                isA11ySwiperSelect(_this.$popup); //스와이프 형태 셀렉트 예외케이스

                isA11ySlidesAccess(); //팝업 스와이퍼 촬영 케이스 접근성

                isA11yDateSpinnerInput(); //조회기간 RadioToggle 접근성

                //page 접근성 팝업 오픈시 swiper 자동재생 접근성 대응
                if(this.$popup.find('.ui-swiper')?.data('ui')){
                    const sw = this.$popup.find('.ui-swiper')?.data('ui')?.swiper;
                    
                    if(sw){
                        this.$popup.find('.ui-swiper')?.data('ui')?.update();
                        this.isA11yAutoPlayAccess(sw);
                    }
                    // if(sw){
                    //     this.$popup.find('.ui-swiper')?.data('ui')?.update();
                    //     if (this.$popup.find('.ui-swiper')?.data('ui')?.defaults.autoplay) {
                    //         this.isA11yAutoPlayAccess(sw);
                    //     }
                        
                    // }
                }

                const selectWrap = _this.$popup[0].querySelectorAll('.carousel-select-group');

                if(selectWrap?.length) {
                    //selectbox popup 적용
                    a11yDebounceLeading(isA11yCarouselSelect(_this.$popup[0], 1500));
                }

                // 240626 pc버전일때 포커스 가능하게 설정 /
                if($('html, body').hasClass('pc')){
                    setTimeout(()=>{
                        const popupEles = document.querySelectorAll('.ui-popup'); //모든팝업 선택
                        isA11ySetAttr(popupEles, "tabindex", "0");
                        if(_this.$popup[0].closest('.fnclPdDetail')){
                            _this.$popup[0].querySelector('.popup-content').setAttribute('tabindex','0');
                        }
                        // 팝업으로 강제 포커스
                        // a11yAcessFocus(this.$popup[0],true);
                    },200);
                    console.log('pc 팝업 열림 a11y');
                }
            }
        })
    }

    isA11yAutoPlayAccess(sw){
        if(!sw) return;

        const {
            activeIndex,
            passedParams:{
                autoplay:{ delay:isAutoCheck }, 
                paging
            }, 
            pagination:{ 
                bullets,
                $el 
            } 
        } = sw;
        
        if(isAutoCheck){
            //TODO - 예외 페이지 및 디자인 다른 재생 분기처리 필요
            if(paging){
                //paging 있을시
                const slideControlBtn = document.createElement('div');
                slideControlBtn?.setAttribute('class','swiper-pagination-bullet stop');
                slideControlBtn?.setAttribute('aria-label', '일시정지');
                slideControlBtn?.setAttribute('role','button');

                $(bullets).each((idx, item) => {
                    if(idx+1 === activeIndex){
                        $(item).attr('aria-label', `총 ${$(bullets)?.length}개 슬라이드 중 ${ idx + 1 }번째 선택됨`);
                    }else{
                        $(item).attr('aria-label', `총 ${$(bullets)?.length}개 슬라이드 중 ${ idx + 1 }번째`);
                    }
                    
                })

                let isToggle = true;

                $(slideControlBtn).on('click',(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    if(isToggle){
                        sw.autoplay.stop();
                        slideControlBtn?.setAttribute('class','swiper-pagination-bullet play');
                        slideControlBtn?.setAttribute('aria-label', '재생');
                    }else{
                        sw.autoplay.start();
                        slideControlBtn?.setAttribute('class','swiper-pagination-bullet stop');
                        slideControlBtn?.setAttribute('aria-label', '일시정지');
                    }
                    
                    isToggle = !isToggle;

                    $(slideControlBtn).focus();
                });
                
                $($el).append(slideControlBtn);
            }else{
                //paging 없을시
            }
        }
    }

    a11yPopupInit(){
        //팝업 닫기실행 로직
        requestAnimationFrame(async () => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행
            if(isA11yCheck){
                try {
                    const removeIdContent = document?.querySelector('#content-mmk');
                    removeIdContent?.setAttribute('aria-hidden','false');
                    removeIdContent?.removeAttribute('aria-hidden');

                    //내계좌(최근에 보낸 계좌) 삭제버튼 접근성 추가
                    isA11yRectList();

                    //돈 보내기 예약버튼 접근성
                    isA11yReservationBtn(this.$popup[0], false);
                } catch (error) {
                    throw new Error(error);
                } finally{
                    //주식 룰렛 focus분기처리

                    if(this.$popup?.find('.roulette-pop-text')?.length){
                        if($('.activeSlide')?.find('.roulette_btn').length){
                            Popup.a11yDetctClosePopup();

                            $('.activeSlide')
                                ?.find('.roulette_btn button')
                                .attr({'tabindex':'0', 'aria-hidden':'false'})
                                .focus();

                            return;
                        }
                    }
                }
            }
        });
    }
    /*! e: FETASK-a11y page 팝업 셀렉트 속성 및 focus로직 v.1.0.0 */
}

export default PopupExternal;
